import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import BasketDialogBoxContentBody from 'general/js/basket/basket-dialog-box-content-body';
import ConfirmationModal from '../../common/utility/ConfirmationModal';
import initialState from '../helpers/form-helpers/initial-state';
import * as userAccountActions from '../../../store/actions/user-account-actions';
import * as formStateHelpers from '../helpers/form-helpers/form-state-helper';
import FormSpinner from '../../common/utility/FormSpinner';
import { isEmpty } from '../../utils/obj-utils';
import { orderHistoryFormConstants } from '../../utils/order-history-form-constants';
import { orderHistoryFormStateConstants } from '../helpers/form-helpers/user-account/order-history-form-state';
import { formConstants } from '../../utils/constants/form-constants';
import { isNullOrUndefined } from '../../../../../general/js/general-helpers';

class UserOrderHistory extends Component {
    constructor(props) {
        super(props);

        const { fileNumberForDisplay } = props;
        this.state = initialState.orderHistoryFormState;
        this.state.fileNumberForDisplay = fileNumberForDisplay;
        this.state.showPopup = false;
        this.state.fileNumber = null;

        this.loadOrderHistoryData = this.loadOrderHistoryData.bind(this);
        this.reloadOrderHistoryData = this.reloadOrderHistoryData.bind(this);
        this.displayOrderHistoryForm = this.displayOrderHistoryForm.bind(this);
        this.handleViewFileDetailsClick = this.handleViewFileDetailsClick.bind(this);
        this.loadFileDetails = this.loadFileDetails.bind(this);
        this.handlePageNumberChange = this.handlePageNumberChange.bind(this);
        this.handleDisplayCancelledFilesChange = this.handleDisplayCancelledFilesChange.bind(this);
        this.handlePrintSummaryButton = this.handlePrintSummaryButton.bind(this);
        this.handlePayReservationClick = this.handlePayReservationClick.bind(this);
        this.handlePrintDocumentInvoiceButtonClick = this.handlePrintDocumentInvoiceButtonClick.bind(this);
        this.handleCloseFileDetailsDisplayForm = this.handleCloseFileDetailsDisplayForm.bind(this);
        this.toggleModalClose = this.toggleModalClose.bind(this);
        this.handlePayReservation = this.handlePayReservation.bind(this);

        this.loadOrderHistoryData();
    }

    componentWillReceiveProps(nextProps) {
        const {
            loading,
            areOrderDetailsLoadedSuccessful,
            orderDetails
        } = nextProps;
        const { fileNumberForDisplay } = this.state;
        if (!loading &&
            fileNumberForDisplay !== 0 &&
            areOrderDetailsLoadedSuccessful) {
            this.setState(formStateHelpers.updateFileSummaryFormState(orderHistoryFormStateConstants.FileDetailsDisplayForm, orderDetails));
        }
    }

    loadOrderHistoryData() {
        const {
            actions, formData, orderHistoryData, displayCancelledFiles
        } = this.props;
        const { fileNumberForDisplay } = this.state;

        if (fileNumberForDisplay !== 0) {
            this.loadFileDetails();
            return;
        }

        if (!isEmpty(orderHistoryData)) {
            return;
        }

        this.loadOrders(actions, formData, displayCancelledFiles);
    }

    loadOrders(actions, formData, displayCancelledFiles) {
        const { orderHistoryActivePageNumber } = this.state;

        actions.getOrderHistoryPages(formData.getOrderHistoryPagesCallbackUrl,
            { displayCancelledFiles, [formConstants.ssoDomain]: formData[formConstants.ssoDomain] });

        actions.getOrderHistory(formData.getOrderHistoryCallbackUrl,
            {
                pageNumber: orderHistoryActivePageNumber,
                displayCancelledFiles,
                [formConstants.ssoDomain]: formData[formConstants.ssoDomain]
            });
    }

    reloadOrderHistoryData() {
        const { actions, formData } = this.props;
        const { displayCancelledFiles } = this.state;
        this.loadOrders(actions, formData, displayCancelledFiles);
    }

    handleViewFileDetailsClick(fileNumber) {
        this.setState(formStateHelpers.updateFileNumberForDisplay(fileNumber), this.loadFileDetails);
    }

    loadFileDetails() {
        const { actions, formData } = this.props;
        const { getOrderDetailsCallbackUrl } = formData;
        const { fileNumberForDisplay } = this.state;
        actions.getOrderDetails(getOrderDetailsCallbackUrl,
            { fileNumber: fileNumberForDisplay, [formConstants.ssoDomain]: formData[formConstants.ssoDomain] });
    }

    handlePageNumberChange(pageNumber) {
        this.setState(formStateHelpers.updateOrderHistoryActivePageNumber(pageNumber), this.reloadOrderHistoryData);
    }

    handleDisplayCancelledFilesChange() {
        this.setState(formStateHelpers.toggleKey('displayCancelledFiles'), this.reloadOrderHistoryData);
    }

    handlePrintSummaryButton(fileNumber) {
        const { actions, formData } = this.props;
        const { downloadFileSummaryPdfCallbackUrl } = formData;
        actions.downloadPdfDocumentById(downloadFileSummaryPdfCallbackUrl,
            { id: fileNumber, [formConstants.ssoDomain]: formData[formConstants.ssoDomain] });
    }

    handlePayReservationClick(fileNumber) {
        const { actions, formData } = this.props;
        const { resumePaymentCallbackUrl, secutixAuthUrl } = formData;

        if (formData.showDialogBox) { this.setState({ showPopup: !this.state.showPopup, fileNumber }); } else {
            actions.resumePaymentByFileNumber({ resumePaymentCallbackUrl, secutixAuthUrl },
                { fileNumber, [formConstants.ssoDomain]: formData[formConstants.ssoDomain] });
        }
    }

    handlePayReservation() {
        const { actions, formData } = this.props;
        const { resumePaymentCallbackUrl, secutixAuthUrl } = formData;
        const { fileNumber } = this.state;

        actions.resumePaymentByFileNumber({ resumePaymentCallbackUrl, secutixAuthUrl },
            { fileNumber, [formConstants.ssoDomain]: formData[formConstants.ssoDomain] });
    }

    toggleModalClose() {
        this.setState({ showPopup: false });
    }

    handlePrintDocumentInvoiceButtonClick(documentId) {
        const { actions, formData } = this.props;
        const { downloadDocumentPdfCallbackUrl } = formData;
        actions.downloadPdfDocumentById(downloadDocumentPdfCallbackUrl,
            { id: documentId, [formConstants.ssoDomain]: formData[formConstants.ssoDomain] });
    }

    handleCloseFileDetailsDisplayForm() {
        this.setState(formStateHelpers.updateOrderHistoryDisplayFormState(orderHistoryFormStateConstants.OrderHistoryDisplayForm), this.loadOrderHistoryData);
    }

    displayOrderHistoryForm() {
        const { formState, orderHistoryForDisplay, orderHistoryActivePageNumber } = this.state;
        const { displayCancelledFiles } = this.props;
        const { formData, orderHistoryData, orderHistoryPages } = this.props;
        const orderHistoryDisplayData = {
            formData,
            displayCancelledFiles,
            orderHistoryData,
            orderHistoryPages,
            orderHistoryActivePageNumber,
            orderHistoryForDisplay,
            handleViewFileDetailsClick: this.handleViewFileDetailsClick,
            handleDisplayCancelledFilesChange: this.handleDisplayCancelledFilesChange,
            handlePageNumberChange: this.handlePageNumberChange,
            handlePrintSummaryButton: this.handlePrintSummaryButton,
            handlePayReservationClick: this.handlePayReservationClick,
            handlePrintDocumentInvoiceButtonClick: this.handlePrintDocumentInvoiceButtonClick,
            handleCloseFormButton: this.handleCloseFileDetailsDisplayForm
        };

        return orderHistoryFormConstants[formState](orderHistoryDisplayData);
    }

    render() {
        const { loading, formData } = this.props;
        const { formTitle } = formData;
        const logoSrc = formData.masterCardDialogBox.logo ? formData.masterCardDialogBox.logo.src : null;
        return (
            <Fragment>
                {loading ? <FormSpinner >/</FormSpinner> : null}
                <h1>{formTitle}</h1>
                {this.displayOrderHistoryForm()}
                <ConfirmationModal
                    isOpen={this.state.showPopup}
                    inputText={'Pay'}
                    onModalClose={this.toggleModalClose}
                    onApproveClick={this.handlePayReservation}
                    isApproveDanger={false}
                    isApproveButtonDisabled={false}
                    onCancelClick={this.toggleModalClose}
                    isCancelButtonDisabled={true}
                    masterCardDialogBoxBanner={formData.masterCardDialogBoxBanner}
                >
                    <BasketDialogBoxContentBody
                        basketDialogBoxTitle={formData.masterCardDialogBox.title}
                        basketDialogBoxMessage={formData.masterCardDialogBox.text}
                        basketDialogBoxLogo = {logoSrc}>
                    </BasketDialogBoxContentBody>
                </ConfirmationModal>
            </Fragment >
        );
    }
}

UserOrderHistory.propTypes = {
    loading: PropTypes.bool.isRequired,
    formData: PropTypes.object.isRequired,
    fileNumberForDisplay: PropTypes.number.isRequired,
};

function mapStateToProps(state) {
    return {
        loading: state.apiStatus.apiCallsInProgress > 0,
        orderHistoryData: state.userAccount.orderHistoryData,
        orderHistoryPages: state.userAccount.orderHistoryPages,
        areOrderHistoryPagesLoadedSuccessful: state.userAccount.areOrderHistoryPagesLoadedSuccessful,
        isOrderHistoryLoadedSuccessful: state.userAccount.isOrderHistoryLoadedSuccessful,
        areOrderDetailsLoadedSuccessful: state.userAccount.areOrderDetailsLoadedSuccessful,
        orderDetails: state.userAccount.orderDetails,
        displayCancelledFiles: isNullOrUndefined(state.userAccount.displayCancelledFiles) ? initialState.orderHistoryFormState.displayCancelledFiles : state.userAccount.displayCancelledFiles
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            getOrderHistory: bindActionCreators(userAccountActions.getOrderHistory, dispatch),
            getOrderHistoryPages: bindActionCreators(userAccountActions.getOrderHistoryPages, dispatch),
            getOrderDetails: bindActionCreators(userAccountActions.getOrderDetails, dispatch),
            downloadPdfDocumentById: bindActionCreators(userAccountActions.downloadPdfDocumentById, dispatch),
            resumePaymentByFileNumber: bindActionCreators(userAccountActions.resumePaymentByFileNumber, dispatch)
        }
    };
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(UserOrderHistory);
